import React, { useState, useEffect } from "react";
import { useDebouncedValue } from "@/hooks/useDebouncedValue";
import SearchInput from "@/components/SearchInput/SearchInput";

/**
 * If you have actual toggles or select menus for "approved" / "sent,"
 * you can import them here. We'll do a simple HTML select for demonstration.
 */

interface EmailNotificationsFiltersProps {
  filters: {
    searchTerm: string;
    approved: string; // "all" | "approved" | "unapproved"
    sent: string; // "all" | "sent" | "unsent"
  };
  onFilterChange: (filterKey: string, value: string) => void;
}

const EmailNotificationsFilters: React.FC<EmailNotificationsFiltersProps> = ({
  filters,
  onFilterChange,
}) => {
  const [searchInput, setSearchInput] = useState(filters.searchTerm);
  const debouncedSearch = useDebouncedValue(searchInput, 500);

  useEffect(() => {
    if (debouncedSearch !== filters.searchTerm) {
      onFilterChange("searchTerm", debouncedSearch);
    }
  }, [debouncedSearch]);

  return (
    <div className="mb-4 space-y-4">
      <SearchInput
        onChange={setSearchInput}
        placeholder="Search by subject or content..."
        value={searchInput}
      />

      <div className="flex space-x-4 items-center">
        <label className="flex flex-col">
          <span className="text-sm font-medium">Approved</span>
          <select
            className="border rounded p-1"
            onChange={(e) => onFilterChange("approved", e.target.value)}
            value={filters.approved}
          >
            <option value="all">All</option>
            <option value="approved">Approved Only</option>
            <option value="unapproved">Unapproved Only</option>
          </select>
        </label>

        <label className="flex flex-col">
          <span className="text-sm font-medium">Sent</span>
          <select
            className="border rounded p-1"
            onChange={(e) => onFilterChange("sent", e.target.value)}
            value={filters.sent}
          >
            <option value="all">All</option>
            <option value="sent">Sent Only</option>
            <option value="unsent">Unsent Only</option>
          </select>
        </label>
      </div>
    </div>
  );
};

export default EmailNotificationsFilters;
